export enum InquiryOfferState {
    Open = 'STATE_OPEN',
    OnGoing = 'STATE_IN_REVIEW',
    Declined = 'STATE_DECLINED',
    Closed = 'STATE_CLOSED',
}
